module.exports = __webpack_public_path__ + "img/search.da20f02e.png";